<template>
    <div style="border: 1px solid #e9e9e9; padding: 11px; min-height: 220px;">
        <div style="position: absolute; right: 40px; top: 40px;">
            <img src="/img/cloudprinter.png">
        </div>

        <div v-if="this.cpOrder">
            <p><b>Status:</b> {{cpOrder.status}}</p>

            <div v-if="cpOrder.status == 'error'">
                <p><b>Message:</b> {{cpOrder.message}}</p>
            </div>

            <div v-if="cpOrder.status != 'error'">
            <p><b>Order reference:</b> {{cpOrder.cp_order_reference}}</p>

            <div v-if="cpOrder.log.length">
                <br>
                <p>
                    <b>Log:</b>
                </p>
                <div class="table-wrapper">
                    <table class="table is-bordered has-mobile-cards" style="width: 70%;">
                        <tbody>
                            <tr draggable="false" v-for="log in cpOrder.log">
                                <td class="has-text-left">{{log.message}}</td>
                                <td class="has-text-left" style="width: 200px">{{dateFormat(log.created_at)}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <br>
            <p>
                <a @click="downloadJson" class="button is-small">
                    Download order json
                </a>
            </p>
            </div>

        </div>
        <div v-else>
            Order is not related to cloudprinter.com.
        </div>
    </div>
</template>

<script>
    import LayoutBasic from '@/layouts/LayoutBasic'
    import axios from 'axios'
    import moment from 'moment'

    export default {
        name: 'order_details',
        components: {
            LayoutBasic
        },

        data() {
            return {
                purchaseOrderId: null,
                cpOrder: null
            };
        },

        methods: {
            downloadJson: function (el) {
                var data = "text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(this.cpOrder.json_data));
                // what to return in order to show download window?

                el.target.setAttribute("href", "data:" + data);
                el.target.setAttribute("download", "data.json");
            },

            getOrder() {
                let scope = this;
                axios.post('/order/get', {zoho_order_id: this.purchaseOrderId})
                  .then(function (response) {
                    const responseData = response.data;
                    responseData.log = JSON.parse(responseData.log);
                    scope.cpOrder = responseData;
                  })
                  .catch(function (error) {
                    console.log(error);
                  })
            },
            dateFormat(date) {
              return moment(date).format('lll')
            }
        },

        created() {
            let scope = this;
            ZOHO.embeddedApp.on("PageLoad", function (data) {
                scope.purchaseOrderId = data.EntityId;
                scope.getOrder();
            });

            ZOHO.embeddedApp.init().then(function () {}).catch(function () {});
        }
    }
</script>
